import { useSearchParams } from 'react-router';

const SORT_OPTIONS = [
  { label: 'Status', value: 'status' },
  { label: 'Latest requested', value: 'latest' },
];

const useTranscriptsSort = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const sortParam = searchParams.get('sort');
  const sortOrder = SORT_OPTIONS.find((option) => option.value === sortParam)?.label ?? 'Status';

  const setSortOrder = (label) => {
    const next = new URLSearchParams(searchParams);
    const value = SORT_OPTIONS.find((option) => option.label === label)?.value;
    if (value) next.set('sort', value);
    else next.delete('sort');
    setSearchParams(next);
  };

  return { sortOrder, setSortOrder };
};

export default useTranscriptsSort;
